import React, { useEffect, useRef, useState } from 'react';
import './TechnicalAnalysis.css'

const TechnicalAnalysis = () => {
  const widgetContainerRef = useRef();
  const [currentIndex, setCurrentIndex] = useState(0);

  const chartConfigs = [
    {
      interval: '1m',
      width: 800,
      isTransparent: false,
      height: 500,
      symbol: 'BSE:SENSEX',
      showIntervalTabs: true,
      displayMode: 'single',
      locale: 'in',
      colorTheme: 'light',
    },
    {
      interval: '1m',
      width: 800,
      isTransparent: false,
      height: 500,
      symbol: "BITSTAMP:UNIUSD",
      showIntervalTabs: true,
      displayMode: 'single',
      locale: 'in',
      colorTheme: 'light',
    },
    {
      interval: '1m',
      width: 800,
      isTransparent: false,
      height: 500,
      symbol: 'EURONEXT:FTSE',
      showIntervalTabs: true,
      displayMode: 'single',
      locale: 'in',
      colorTheme: 'light',
    },
    {
      interval: '1m',
      width: 800,
      isTransparent: false,
      height: 500,
      symbol: 'NASDAQ:NDX',
      showIntervalTabs: true,
      displayMode: 'single',
      locale: 'in',
      colorTheme: 'light',
    },
  ];
  useEffect(() => {
    const loadScript = () => {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-technical-analysis.js';
      script.async = true;
      script.innerHTML = JSON.stringify(chartConfigs[currentIndex]);
      if (widgetContainerRef.current) {
        widgetContainerRef.current.innerHTML = '';
        widgetContainerRef.current.appendChild(script);
      }
    };

    loadScript();

    const timeoutId = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % chartConfigs.length);
      widgetContainerRef.current.classList.add('zoom-in-out');
      setTimeout(() => {
        widgetContainerRef.current.classList.remove('zoom-in-out');
      }, 500);
    }, 10000);

    return () => {
      clearInterval(timeoutId);
      if (widgetContainerRef.current) {
        widgetContainerRef.current.innerHTML = '';
      }
    };
  }, [currentIndex, chartConfigs]);

  return (
      <div className="tradingview-widget-container" ref={widgetContainerRef} style={{ boxShadow: '0 0 20px rgba(0, 0, 0, 0.5)' }}>
        <div className="tradingview-widget-container__widget"></div>
      </div>
    );
  };

export default TechnicalAnalysis;